import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import procedureTranslations from "../locales/procedureTranslations";
import { LanguageContext } from "../locales/LanguageContext";

const Procedure = () => {
  const { lang } = useContext(LanguageContext);
  const t = procedureTranslations[lang] || {};

  return (
    <>
      <Helmet>
        <title>AKAAL KIDS | {t.pageTitle || "Enrollment Process"}</title>
      </Helmet>
      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 8px 32px #f6815e44",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
           fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 11,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          {t.pageTitle || "Enrollment Process"}
        </h1>
      </div>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <p
              style={{
                fontSize: "1.25rem",
                color: "#555",
                lineHeight: "1.8",
                textAlign: "justify",
                marginBottom: 40,
                background: "#fffbe6",
                borderRadius: 12,
                boxShadow: "0 2px 12px #f6b93b22",
                padding: "18px 24px",
              }}
            >
              {t.intro}
            </p>
            {(t.steps || []).map((step, idx) => (
              <div
                key={idx}
                className="card border-0 shadow-lg p-4 mb-5"
                style={{
                  borderRadius: 22,
                  background:
                    idx % 2 === 0
                      ? "linear-gradient(120deg, #fffbe6 0%, #f6b93b33 100%)"
                      : "linear-gradient(120deg, #f6fafd 0%, #f6b93b11 100%)",
                  boxShadow:
                    idx % 2 === 0
                      ? "0 6px 32px #f6b93b44"
                      : "0 6px 32px #1976d244",
                }}
              >
                <h3
                  style={{
                    color: idx % 2 === 0 ? "#b26a00" : "#1976d2",
                    fontWeight: 900,
                    marginBottom: 16,
                    textAlign: "center",
                    fontSize: "1.5rem",
                    letterSpacing: 1,
                    textShadow:
                      idx % 2 === 0
                        ? "0 2px 12px #f6b93b55"
                        : "0 2px 12px #1976d255",
                  }}
                >
                  {step.title}
                </h3>
                <div style={{ color: "#444", marginBottom: 8 }}>
                  {step.desc}
                </div>
                <ul style={{ color: "#444", fontSize: 15, paddingLeft: 18 }}>
                  {(step.points || []).map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
            <div
              className="card border-0 shadow-lg p-4 mb-5"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #fffbe6 0%, #f6b93b33 100%)",
                boxShadow: "0 6px 32px #f6b93b44",
              }}
            >
              <h3
                style={{
                  color: "#b26a00",
                  fontWeight: 900,
                  marginBottom: 16,
                  textAlign: "center",
                  fontSize: "1.5rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #f6b93b55",
                }}
              >
                {t.supportHeading}
              </h3>
              <ul style={{ color: "#444", fontSize: 15, paddingLeft: 18 }}>
                {(t.supportPoints || []).map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
            <div
              className="card border-0 shadow-lg p-4 mb-5"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #f6fafd 0%, #f6b93b11 100%)",
                boxShadow: "0 6px 32px #1976d244",
              }}
            >
              <h3
                style={{
                  color: "#1976d2",
                  fontWeight: 900,
                  marginBottom: 16,
                  textAlign: "center",
                  fontSize: "1.5rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #1976d255",
                }}
              >
                {t.notesHeading}
              </h3>
              <ul style={{ color: "#444", fontSize: 15, paddingLeft: 18 }}>
                {(t.notes || []).map((note, idx) => (
                  <li key={idx}>{note}</li>
                ))}
              </ul>
            </div>
            <div
              className="card border-0 shadow-lg p-4 mb-5 text-center"
              style={{
                borderRadius: 22,
                background:
                  "linear-gradient(120deg, #fffbe6 0%, #f6b93b33 100%)",
                boxShadow: "0 6px 32px #f6b93b44",
              }}
            >
              <h3
                style={{
                  color: "#b26a00",
                  fontWeight: 900,
                  marginBottom: 16,
                  textAlign: "center",
                  fontSize: "1.5rem",
                  letterSpacing: 1,
                  textShadow: "0 2px 12px #f6b93b55",
                }}
              >
                {t.readyHeading}
              </h3>
              <div
                style={{ color: "#444", marginBottom: 16, fontSize: "1.15rem" }}
              >
                {t.readyText}
              </div>
              <div className="d-flex justify-content-center gap-3 flex-wrap">
                <a
                  href="/enroll"
                  className="btn btn-lg"
                  style={{
                    background:
                      "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
                    color: "#fff",
                    borderRadius: 32,
                    padding: "12px 36px",
                    fontSize: "1.2rem",
                    fontWeight: 700,
                    border: "none",
                    boxShadow: "0 4px 16px #f6815e44",
                    textDecoration: "none",
                  }}
                >
                  {t.enrollBtn}
                </a>
                <a
                  href="https://wa.me/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-lg"
                  style={{
                    background: "#25D366",
                    color: "#fff",
                    borderRadius: 32,
                    padding: "12px 36px",
                    fontSize: "1.2rem",
                    marginLeft: 15,
                    fontWeight: 700,
                    border: "none",
                    boxShadow: "0 4px 16px #25D36644",
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <span role="img" aria-label="whatsapp">
                    💬
                  </span>{" "}
                  {t.whatsappBtn}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Procedure;
